import { BREAKPOINTS } from '@skyscanner/backpack-web/bpk-component-breakpoint';

import component from './BpkBreakpointWrapper';

export default component;
export { BREAKPOINTS };
